import { getTranslationDictionarySchema, TranslationDictionary } from '../translate/translation-dictionary.model';

export interface QualityCheckItemTemplate {
  id: string;
  companyId: string;
  order: number;
  name: string;
  nameTranslation: TranslationDictionary;
  code: string;
  created?: Date;
  comment: string;
  commentTranslation: TranslationDictionary;
  reference: string;
  referenceTranslation: TranslationDictionary;
}

export const qualityCheckItemTemplateChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  code: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  nameTranslation: getTranslationDictionarySchema(
    'Required for new entries. Othwerise should be only set if the intend is to change it.'
  ),
  commentTranslation: getTranslationDictionarySchema('Othwerise should be only set if the intend is to change it.'),
  referenceTranslation: getTranslationDictionarySchema('Othwerise should be only set if the intend is to change it.'),
};
